module.exports = __webpack_public_path__ + "static/img/model-box-bg_dark.e1a126d2.png";